import React from 'react';
import PropTypes from 'prop-types';

import './IndexedLegend.less';

export function IndexedLegend({
  index, text,
}) {
  return (
    <legend className="IndexedLegend">{`${index}. ${text}`}</legend>
  );
}

IndexedLegend.propTypes = {
  index: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
};

export default IndexedLegend;
